//CSS
import cssClasses from "./PayloadModal.module.css";
//Sub Components

import CloseIcon from '@mui/icons-material/Close';

import Modal from "@mui/material/Modal";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ReactJson from 'react-json-view'
// import CloseIcon from "@mui/icons-material/Close";

import { supabase } from "../../supabaseClient";
import { errorTost, offlineToast, successTost } from "../../Services/Toast";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { Network } from "@capacitor/network";
import payloadCopyButton from '../../Assets/Images/Dashboard/payloadCopyButton.svg'

function PayloadModal({ projectName, leadName, type, payload, open, closeHandler }) {

  console.log("payload", typeof payload)


  const copyToClipboard = () => {
    // Convert the payload object to a JSON string
    const textToCopy = JSON.stringify(payload, null, 2);

    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        console.log('Payload copied to clipboard');
        successTost("Copied To Clipboard")

      })
      .catch(err => {
        console.error('Failed to copy payload to clipboard: ' + err);
      });
  };

  return (
    <Modal
      open={open}
      onClose={closeHandler}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className={cssClasses.container} style={{minWidth: "60%",
        height: "75%"}}>
        <div className={cssClasses.header} style={{ marginBottom: "1rem"}} >
          <p className={cssClasses.heading}>Payload</p>
          <CloseIcon sx={{ fontSize: "3rem", cursor: "pointer" }} onClick={closeHandler} /> {/* Close the modal when the close icon is clicked */}
        </div>
        <div style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          alignItems: "center",
        width: "100%",
        height: "85%",
        gap: "1.5rem"
        }} >
          <div style={{display: "flex",
          justifyContent: "center",
          alignItems: "center", gap: "1rem", width: "100%"}} >
       <p style={{textAlign: "center", fontWeight: "normal", fontSize: "1.5rem"}}>
       Project Name- {projectName} | Lead Name- {leadName} | Type- {type}
     </p>
    
       </div>

          <div className={cssClasses.wrapper} style={{ backgroundColor: "#f2f4f7",height: "45vh", width: "50vw"}} >
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center",alignItems: "center", width: "45vw", height: "40vh"}}>
          <ReactJson src={payload} style={{fontSize: "1.2rem", height: "35vh", width: "40vw"}}/>
         
           </div>
          
              </div>
              <img className={cssClasses.icon} src={payloadCopyButton} alt="" 
              style={{ color: "white", cursor: "pointer", fontSize: "2.5rem", alignSelf: "flex-end", marginRight: "2rem" }}
              onClick={copyToClipboard} 
              />  

        </div>

      </div>
    </Modal >
  );
}


export default PayloadModal;
